import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const OMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="OM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F50101"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path fill="#F50101" d="M0 0h6v12H0z" />
        <Path
          fill="#F7FCFF"
          d="M5.308.992c.024-.039.082-.02.078.025a6.182 6.182 0 0 1-.62 2.08h.01v-.015c0-.024.02-.044.044-.044h1.055c.024 0 .043.02.043.044v.663c0 .024-.02.043-.043.043H4.82a.044.044 0 0 1-.044-.043v-.348h-.133a.296.296 0 0 1-.125.137c-.13.209-.277.418-.448.62-.006.007-.015.014-.021.022a13.65 13.65 0 0 0 2.025 1.749c.04.028.014.088-.032.075-.449-.123-1.482-.469-2.396-1.215a.682.682 0 0 1-.55.26h-.032a7.145 7.145 0 0 1-2.197.977c-.043.01-.068-.04-.036-.07l1.106-1c-.461-.09-.83-.26-.83-.588 0-.552 1.523-.42 1.742-.399a5.702 5.702 0 0 1-.277-.39.298.298 0 0 1-.271-.178h-.133v.348c0 .024-.02.043-.043.043H1.07a.044.044 0 0 1-.044-.043v-.663c0-.024.02-.044.044-.044h1.055c.024 0 .043.02.043.044v.016h.125a6.735 6.735 0 0 1-.682-2.06c-.006-.046.053-.065.076-.024.184.315.62 1.018 1.315 1.922l.05-.402s.273-.066.273-.286V1.79l-.45-.372L3.47 1l.565.417-.412.372v.46s.228.208.3.285v.456A19.233 19.233 0 0 0 5.308.992ZM2.575 3.038a.243.243 0 0 0-.244.243c0 .133.11.241.244.242a.244.244 0 0 0 .245-.242.244.244 0 0 0-.245-.243Zm1.794 0a.243.243 0 0 0-.244.243c0 .133.109.242.244.242a.243.243 0 0 0 .244-.242.243.243 0 0 0-.244-.243Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
